import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import { service } from '@ember/service'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class StorylandsLessonsReRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRe = 're'
    const precinct: LegacyPrecinctStorylands = 'storylands'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      precinct,
      uiScope,
      scopedStudents: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRe, scope: StudentsScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      storylandsHistory: studentEvents.storylandsHistory(product, scope, period),
      storylandsTotals: studentEvents.storylandsTotals(product, scope, period),
    })
  }
}

export default StorylandsLessonsReRoute
